/* globals FB: false */

import store from 'base/store'

function setupFacebook() {
  window.fbAsyncInit = () => {
    FB.init({
      appId: store.getState().appConfig.facebookApiKey,
      channelUrl: '//' + window.location.host + '/channel.html',
      status: true,
      cookie: true,
      oauth: true,
      xfbml: true,
      version: 'v2.9',
      status: true,
    })
  }

  // prettier-ignore
  ;(function (d, s, id) {
    var js,
      fjs = d.getElementsByTagName(s)[0]
    if (d.getElementById(id)) {
      return
    }
    js = d.createElement(s)
    js.id = id
    js.src = 'https://connect.facebook.net/en_US/sdk.js'
    fjs.parentNode.insertBefore(js, fjs)
  })(document, 'script', 'facebook-jssdk')
}

export default setupFacebook
